import { useEffect, useState } from "react";
import { fetchActiveFaqs } from "../api/faqsApi";

export default function FaqsSection() {
  const [faqs, setFaqs] = useState([]);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    let on = true;
    (async () => {
      try {
        const data = await fetchActiveFaqs();
        if (!on) return;
        const list = Array.isArray(data) ? data : [];
        setFaqs(list);
        setOpenId(list[0]?.id ?? null);
      } catch {
        if (on) setFaqs([]);
      }
    })();
    return () => {
      on = false;
    };
  }, []);

  if (!faqs.length) return null;

  return (
    <section className="cl-faqs" id="faqs">
      <div className="cl-container cl-faqs-inner">
        <div className="cl-faqs-head">
          <p className="cl-eyebrow center">FAQs</p>
          <h2 className="cl-title center">Frequently asked questions</h2>
          <p className="cl-faqs-sub">
            Quick answers about how Click Law works and how we connect you with independent legal professionals.
          </p>
        </div>

        <div className="cl-faq-list">
          {faqs.map((item) => {
            const open = openId === item.id;
            return (
              <div className={`cl-faq-item${open ? " is-open" : ""}`} key={item.id}>
                <button
                  type="button"
                  className="cl-faq-q"
                  aria-expanded={open}
                  onClick={() => setOpenId(open ? null : item.id)}
                >
                  <span>{item.question}</span>
                  <span className="cl-faq-icon" aria-hidden="true">
                    {open ? "−" : "+"}
                  </span>
                </button>
                {open ? <div className="cl-faq-a">{item.answer}</div> : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
